<template>
	<div class="row" style="width: 100px;">
        <div class="dropdown mx-auto">
            <button class="btn btn-secondary" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                <i class="fas fa-ellipsis-v"></i>
            </button>
            <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownMenuButton">
                <router-link tag="a" class="dropdown-item" :to="target">Edit</router-link>
                <div class="dropdown-divider"></div>
                <a @click="$emit('deletedId', selectedId)" class="dropdown-item" :href="`#${targetModal}`" data-toggle="modal">Hapus</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
	name: 'ActionEditDelete',
	props: ['target', 'selectedId', 'targetModal']
}
</script>